/* eslint-disable consistent-return */
import Base from '../Base/index';
import { isArray } from '../utils';

// 研究模块(不考虑不在坐标轴棋子的情况)
export default class Resource extends Base {
  // 初始化
  constructor(props) {
    // 传给父亲
    super({
      ...props,
      type: 0, // 画所有棋子
      chessClick: (sprite) => { // 棋子点击事件
        this.chessEvent(sprite);
      },
      complete: () => {
        // 初始化研究模式(分支棋子也遍历)
        this.initResource(true);
      },
    });
    // 当前棋子颜色
    this.nowChessColor = false;
    // 棋子步数
    this.nowChessStep = 0;
    // 回退记录当做棋子步数
    this.nowBackChessStep = 0;
    // 当前下子顺序
    this.chessStep = [];
  }

  chessEvent = (sprite) => {
    if (this.mianDown) {
      console.log('等等');
      return false;
    }
    if (sprite.alpha !== 1) {
      this.nowChessColor = this.nowChessColor === 'B' ? 'W' : 'B';
      // 重置落子顺序
      this.reloadChessStep();
      this.downResourceChess(sprite.point.letter, this.nowChessColor);
      this.saveNowStep(sprite.point.letter, this.nowChessColor);
      this.options.LaZi && this.options.LaZi(sprite, this);
      this.stage.update();
    }
  };

  // 重置落子顺序
  reloadChessStep() {
    this.nowChessStep = this.nowBackChessStep;
    this.chessStep = this.chessStep.slice(0, this.nowChessStep);
  }

  initResource(isDeep) {
    if (this.sgfParse) {
      const { children } = this.sgfParse;
      // 初始化content
      this.initSgfContent();
      // 遍历子节点
      if (isDeep && children.length > 0) {
        this.deepChess(children[0]);
      }
      this.stage.update();
    }
  }

  deepChess(node) {
    const { data, children } = node;
    for (const item in data) {
      if (item === 'B' || item === 'W') {
        this.nowChessColor = item;
        this.downResourceChess(data[item][0], item);
        this.saveNowStep(data[item][0], item);
      }
    }
    if (children.length > 0) {
      this.deepChess(children[0]);
    }
  }

  saveNowStep(color, letter) {
    this.chessStep.push({
      [color]: letter,
    });
  }

  downResourceChess(v, type, step) {
    // 没有步数才做步数累加
    if (!step) {
      this.nowChessStep++;
      this.nowBackChessStep++;
    }
    const num = this.letterTurnAllNum(v);
    const sprite = this.chess[num[0]][num[1]];
    sprite.chessStep = step || this.nowChessStep; // 标识当前棋子在第几步
    if (type == 'B') {
      this.drawBackChess(sprite, sprite.x, sprite.y);
    } else if (type == 'W') {
      this.drawWhiteChess(sprite, sprite.x, sprite.y);
    }
    // 提子
    this.tiZiMethod(num, type);
  }

  // 去第一步
  goFirstStep() {
    const { nowBackChessStep } = this;
    this.goStep(1 - nowBackChessStep);
  }

  // 最后一步
  goLastStep() {
    const { nowChessStep, nowBackChessStep } = this;
    this.goStep(nowChessStep - nowBackChessStep);
  }

  // 前进后退
  goStep(step) {
    const { nowChessStep, nowBackChessStep, stage } = this;
    const backStep = nowBackChessStep + step;

    if (backStep < 0) {
      return {
        code: 1,
        message: '这是第一步,不能向前了',
      };
    } if (backStep > nowChessStep) {
      return {
        code: 2,
        message: '这是最后一步,不能向后了',
      };
    }
    // 所有棋子先变成透明色
    this.container.moreChessContainer.removeAllChildren();
    this.container.chessStepContainer.removeAllChildren();
    this.drawAllChess();
    // 重新初始化
    this.initResource();
    this.nowBackChessStep = backStep;
    // 重置上次棋子颜色
    if (this.nowChessColor == 'B') {
      this.nowChessColor = 'W';
    } else if (this.nowChessColor == 'W') {
      this.nowChessColor = 'B';
    }
    const nowChess = this.chessStep.slice(0, backStep);
    nowChess.forEach((v, index) => {
      for (const k in v) {
        this.downResourceChess(k, v[k], index + 1);
      }
    });
    stage.update();
  }
}
